import React from 'react'

const About = () => {
  
  return (
    <>
    <div className='conatiner flex text-align justify-center'>
    <h5>YourBook is a platfrom where you can store your notes online at the cloud from anywhere/anytime and get remote access to it.</h5>
    <span className='flex'>&#169; Kuldeep</span>
    </div>
    </>
  )
}

export default About
